/**
* map JS
* -----------------------------------------------------------------------------
*
* All the JS for the map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// VARS that are set in map.php:
// mapLocations - array of objects [{address, city, state, zip, coordinates: {lat, lng}}]
// mapPin - url string of pin image
// mapStyle - url string of mapbox studio style link
// mapKey - string of mapbox api key
( function( app ) {
  const COMPONENT = {

    className: 'map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // mapKey variable is set in the PHP file
      mapboxgl.accessToken = ll_mapbox.token;
      $( '.map-box' ).each( function() {
        // Initialize the map
        const rawLocations = $( this ).data( 'locations' );
        const thisMapId = $( this ).attr( 'id' );

        loadLocations( rawLocations, thisMapId );
      } );

      function loadLocations( locations, mapId ) {
        let pin;
        let zoom;

        if ( mapId == 'nav-mapbox' ) {
          pin = ll_mapbox.small_pin;
          zoom = 8;
        } else {
          pin = ll_mapbox.pin;
          zoom = 10;

          if ( window.innerWidth > 660 && window.innerWidth < 1024 ) {
            zoom = 9;
          } else if ( window.innerWidth < 660 ) {
            zoom = 8;
          }
        }

        if ( locations ) {
          const map = new mapboxgl.Map( {
            container: mapId, // mounts on element with id of "mapbox"
            style: ll_mapbox.style, // stylesheet URL set in PHP file
            // this map is centered on the US, but you should change it your location
            center: [-94.58200485909119, 38.955459101125605],
            zoom: zoom,
          } );

          // Wait for the map to load
          map.on( 'load', () => {
            // load the pin image (has to be png or jpg, [SVG DOESN'T WORK])
            // mapPin is set in PHP file
            map.loadImage( pin, ( err, img ) => {
              if ( err ) throw err;
              // Will rerference "pin" later
              map.addImage( 'll_pin', img );
              const features = [];
              // for multi-location map, iterate over locations and add them to the array of features
              locations.forEach( ( loc, index ) => {
                const feature = {
                  type: 'Feature',
                  properties: {
                    'gmbLink': ( loc.gmb_link ? `<a class="hidden lg:inline-block mt-1 py-2 ml-5 pr-2 font-medium text-sm border-b border-transparent hover:border-brand-primary" href="${loc.gmb_link}" target="_blank">More Info <svg class="icon icon-right-arrow-bold text-xs ml-2"><use xlink:href="#icon-right-arrow-bold"></use></svg></a>` : '' ),
                    'image': ( loc.image_url ?`<div class="loc-image hidden lg:block" style="background-image: url(${loc.image_url})"></div>` : '' ),
                    'providerLink': ( loc.provider_link ? `<a class="btn py-2 pr-2 font-medium mt-3" href="/our-providers?location=${loc.provider_link}">See Providers <svg class="icon icon-right-arrow-bold text-xs ml-2"><use xlink:href="#icon-right-arrow-bold"></use></svg></a>` : '' ),
                    'description':
                      `<p class="font-medium text-base mb-3">${loc.title}</p>
                      <address class="not-italic text-xs mb-5">` +
                        ( loc.address.loc_title ? `<span class="block">${loc.address.loc_title}</span>` : '' ) +
                        `<span class="block">${loc.address.street}</span>
                        <span class="block">${loc.address.city}, ${loc.address.state} ${loc.address.zip}</span>
                      </address>
           
                      <a class="btn py-2 pr-2 font-medium" href="https://www.google.com/maps/place/${loc.address.street}+${loc.address.city}+${loc.address.state}" target="_blank">Get Directions <svg class="icon icon-right-arrow-bold text-xs ml-2"><use xlink:href="#icon-right-arrow-bold"></use></svg></a>`,
                    'icon': 'll_pin',
                  },
                  geometry: {
                    type: 'Point',
                    coordinates: [parseFloat( loc.coordinates.long ), parseFloat( loc.coordinates.lat )],
                  },
                };

                features.push( feature );
              } );

              // add this "geojson" object to the map, passing in the features array
              map.addSource( 'points', {
                type: 'geojson',
                data: {
                  type: 'FeatureCollection',
                  features,
                },
              } );

              // console.log( mapId );
              const pointMapID = 'points-' + mapId;
              // console.log( 'pointMapID ' + pointMapID );
              // create a symbol layer using the "point" source that we just added
              map.addLayer( {
                id: pointMapID,
                type: 'symbol',
                source: 'points',
                layout: {
                  'icon-image': ['get', 'icon'], // uses the "pin" image we added above
                  'icon-anchor': 'bottom', // will put the bottom center of the pin on the location
                  'icon-allow-overlap': true,
                },
              } );

              // map.on( 'click', function( e ) {
              //   console.log( 'well map click' );
              // } );


              // this handles the popups when the pin is clicked
              // image and Google My Business links are optional content
              // i'm sure there's a better way to add those if filled but
              map.on( 'click', pointMapID, function( e ) {
                const coordinates = e.features[0].geometry.coordinates.slice();
                const image = e.features[0].properties.image;
                const gmbLinkIt = e.features[0].properties.gmbLink;
                const providerLinkIt = e.features[0].properties.providerLink;
                const description = image + e.features[0].properties.description + providerLinkIt + gmbLinkIt;

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while ( Math.abs( e.lngLat.lng - coordinates[0] ) > 180 ) {
                  coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                new mapboxgl.Popup( {
                  offset: {'bottom': [0, -49]},
                  closeButton: false,
                } )
                    .setLngLat( coordinates )
                    .setHTML( description )
                    .addTo( map );
              } );


              // make the cursor a pointer when over the pin
              map.on( 'mouseenter', pointMapID, function() {
                map.getCanvas().style.cursor = 'pointer';
              } );
              map.on( 'mouseleave', pointMapID, function() {
                map.getCanvas().style.cursor = '';
              } );

              map.scrollZoom.disable();
            } );
          } );
        }
      }

      /*
       * LOCATION SEARCHING
       */

      const locationInput = $( '#location-search input' )[0];
      const distance = 10;
      mapboxgl.accessToken = ll_mapbox.token;

      $( '#get-current-location' ).click( function() {
        $( '#location-search' ).find( 'button' ).attr( 'disabled', true );
        $( '.navbar .locations-list' ).addClass( 'is-loading' );
        if ( navigator.geolocation ) {
          navigator.geolocation.getCurrentPosition( function( position ) {
            loadNewLocations( [position.coords.latitude, position.coords.longitude], distance );
          } );
        } else {
          alert( 'Unable to retrieve your current location.' );
        }
      } );

      $( '#location-search' ).submit( function( e ) {
        e.preventDefault();
        $( '#location-search' ).find( 'button' ).attr( 'disabled', true );
        $( '.navbar .locations-list' ).addClass( 'is-loading' );

        const value = $( this ).find( 'input[name="search_location"]' ).val();
        searchLocations( value, distance );
      } );

      function searchLocations( searchVal, searchDistance ) {
        $.get( 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + searchVal + '.json?country=US&access_token=' + mapboxgl.accessToken, function( data ) {
          loadNewLocations( [data.features[0].center[1], data.features[0].center[0]], searchDistance );
        } );
      }

      function loadNewLocations( coords, searchDistance ) {
        $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'location_search',
              params: {
                lat: coords[0],
                lng: coords[1],
                distance: searchDistance,
              },
            },
            function( data, textStatus, xhr ) {
              data = $.parseJSON( data );
              if ( data.status === 'success' ) {
                let locationsCards = '';
                $( data.response.location_result ).each( function( key, val ) {
                  locationsCards += val.template;
                } );
                $( '.navbar .locations-list' ).html( locationsCards );
                const newLocations = [];
                $( '.navbar .locations-list .nav-location' ).each( function( key, val ) {
                  const thisLocation = {};
                  thisLocation.address = {};
                  thisLocation.coordinates = {};
                  thisLocation.address.street = $( val ).find( '.address .street' ).text();
                  thisLocation.address.city = $( val ).find( '.address .city' ).text();
                  thisLocation.address.state = $( val ).find( '.address .state' ).text();
                  thisLocation.address.zip = $( val ).find( '.address .zip' ).text();
                  thisLocation.phone = $( val ).find( '.phone' ).text();
                  thisLocation.formattedPhone = $( val ).find( '.phone' ).text().replace( /[.\D+]/gm, '' );
                  thisLocation.title = $( val ).find( '.title' ).text();
                  thisLocation.coordinates.lat = $( val ).attr( 'data-lat' );
                  thisLocation.coordinates.long = $( val ).attr( 'data-long' );

                  newLocations.push( thisLocation );
                } );
                loadLocations( newLocations, 'nav-map-mapbox' );
                $( '.nav-map-wrap' ).show();
                $( '#location-search' ).find( 'button' ).removeAttr( 'disabled' );
                $( '.navbar .locations-list' ).removeClass( 'is-loading' );
              }
            }
        );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'map', COMPONENT );
} )( app );
